<template>
  <div>
    <HeadlineContainer headline="Memberships" :breadcrumbs="[{text: 'Memberships'}]"/>

    <div v-if="!loading" class="container">
      <MembershipList :users="users" :portals="portals"/>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import MembershipList from '../../../components/Relations/Memberships/Panels/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'

export default {
  components: {MembershipList, HeadlineContainer},

  data() {
    return {
      portals: null,
      users: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.loading = true

      Promise.all([
        http.get('/api/v2/users', {page_size: 100}),
        http.get('/api/v2/portals', {page_size: 100})
      ]).then(responses => {
        this.users = responses[0].data.data

        this.portals = responses[1].data.data

        this.loading = false
      })
    }
  }
}
</script>
